import styles from './style.module.css';
import useItem from './hook';

export default function Item({ onSelect, children }) {
	const onClick = useItem(onSelect);
	const [style=null, click=null] = onSelect ? [{ cursor: 'pointer' }, onClick] : [];
	return <div style={style} className={styles.body} onClick={click}>{children}</div>
}